import pagination from "../static/pagination";
import exportData from "../static/exportData";

const moduleName = "kampusModule";

const state = {
  isLoadMore: false,
  isFilter: false,
  response: {},
  pagination: pagination(),
  detailOwner: {},
  dataJenisTraining: {},
  detailJenisTraining: {},
  trainingCreate: {},
  listJenisExist: {},
  riwayatTraining: {},
  listAkunKeuangan: [],
  jadwalUnavailable: [],
  infoTagihan: {},
  detailBayar: {},
  hargaTraining: {
    harga: "",
  },

  formJadwal: {
    id_jenis_training: "",
    jadwal_training: [
      { jadwal_mulai: "", jadwal_selesai: "", sesi: 0 },
      { jadwal_mulai: "", jadwal_selesai: "", sesi: 0 },
    ],
    nama_owner: "",
    no_telp: "",
    pembayaran: {
      kode_promo: "",
      akun: "",
      metode_pembayaran: 0,
      kode_unik: 0,
    },
  },

  jadwalDirection: {
    afterChoose: "",
    rangeOnDate: "",
  },

  jadwal: {
    jadwalMulai: "",
    jadwalSelesai: "",
  },

  detailTraining: {},
  dataUlasan: "",

  dataListTraining: [],
  countListTraining: 0,

  dataRescedule: {
    id_detail_training: "",
    jadwal_mulai: "",
    jadwal_selesai: "",
    jadwal_ke: "",
    jadwal_change: "",
    //ketika paid online butuh jadwal range
    jadwal_range: "",
  },

  date_format: {
    toPost: "",
    toDisplay: "",
  },

  dataTimeExist: {},

  dataResceduleAfterPost: {},

  dataDetailPembayaran: {},

  dataJadwalUnavailable: [],

  lastItemToView: {},
  promo: [
    {
      dikson: 0,
      available: false,
    },
  ],
};

export { state as default, moduleName };
